module.exports = __webpack_public_path__ + "static/media/passport.c0f550f7.svg";